export default __webpack_public_path__ + "static/media/kitchen3-after3-1024w.84ed215f.png";